/**
 * 数値解答の解釈。
 *
 * サーバー側の `parseNumericAnswer`（app/src/core/normalize.ts）と
 * 同じ規則で判定する。**片方だけを直さないこと。**
 * 画面が通した入力をサーバーが弾けば、参加者には理由の分からない誤答減点になる。
 * 逆に画面が厳しすぎれば、正しい解答が送信できない。
 *
 * ここで止めるのは「数値として読めない入力」だけで、
 * 値が正解かどうかは一切判定しない。それはサーバーの仕事である。
 */

/** あらゆる種類の空白文字（NFKC後も残る全角スペースを含む） */
const WHITESPACE_RE = /[\s　 ]/g;

/**
 * 数値として解釈する。解釈できなければ null。
 *
 * 全角数字は NFKC により半角へ変換されるため「１０」も 10 として扱う。
 * カンマ区切り（1,000）も許容する。
 */
export function parseNumericAnswer(input: string): number | null {
  const normalized = input.normalize("NFKC").trim().replace(WHITESPACE_RE, "");
  if (normalized === "") return null;
  const stripped = normalized.replace(/,/g, "");
  if (!/^[+-]?(\d+\.?\d*|\.\d+)$/.test(stripped)) return null;
  const value = Number(stripped);
  return Number.isFinite(value) ? value : null;
}

/** 数値として読めるか */
export function isNumericAnswer(input: string): boolean {
  return parseNumericAnswer(input) !== null;
}
